<template>
  <span>
    <ListingTable :columnCount="6" :rowDate="engineerLeave">
      <template v-slot:thead>
        <!-- <template v-slot:default> -->
        <thead class="custom-border-bottom custom-border-top">
          <tr>
            <th width="150" class="simple-table-th">Leave #</th>
            <th width="150" class="simple-table-th">Leave Type</th>
            <th width="150" class="simple-table-th">Leave Date</th>
            <th width="150" class="simple-table-th">Day</th>
            <th width="150" class="simple-table-th">Created At</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="engineerLeave.length > 0">
            <tr
              v-for="(leave, index) in engineerLeave"
              :key="index"
              :class="{
                'custom-border-top': index == 0,
                'orange_lighten-5': index % 2 == 0,
              }"
            >
              <td class="simple-table-td">
                <template v-if="leave?.leave_value">
                  <span class="font-weight-500">
                    <v-chip
                      style="height: 25px"
                      class=""
                      color="cyan"
                      @click="toLeaves(leave?.leave_value?.id)"
                      dence
                      text-color="white"
                    >
                      {{ leave?.leave_value?.barcode }}
                    </v-chip>
                  </span>
                </template>
                <em v-else class="text-muted"> no leave</em>
              </td>
              <td class="simple-table-td">
                <template v-if="leave?.leave_value?.leave_types">
                  <span class="font-weight-500">{{
                    leave?.leave_value?.leave_types
                  }}</span>
                </template>
                <em v-else class="text-muted"> no leave type</em>
              </td>
              <td class="simple-table-td">
                <template v-if="leave?.leave_date">
                  <span class="font-weight-500">{{
                    formatDate(leave?.leave_date)
                  }}</span>
                </template>
                <em v-else class="text-muted"> no date</em>
              </td>
              <td class="simple-table-td">
                <template v-if="leave?.leave_date_weak">
                  <span class="font-weight-500">{{
                    leave?.leave_date_weak
                  }}</span>
                </template>
                <em v-else class="text-muted"> no week</em>
              </td>
              <td class="simple-table-td">
                <template v-if="leave?.added_at">
                  <span class="font-weight-500">{{
                    formatDate(leave.added_at)
                  }}</span>
                </template>
                <em v-else class="text-muted"> no date</em>
              </td>
            </tr>
          </template>
          <template v-else>
            <template v-if="pageLoading">
              <tr v-for="row in 5" :key="row">
                <td>
                  <v-skeleton-loader
                    type="text"
                    class="custom-skeleton table-rows-text"
                  ></v-skeleton-loader>
                </td>
                <td>
                  <v-skeleton-loader
                    type="text"
                    class="custom-skeleton table-rows-text"
                  ></v-skeleton-loader>
                </td>
                <td>
                  <v-skeleton-loader
                    type="text"
                    class="custom-skeleton table-rows-text"
                  ></v-skeleton-loader>
                </td>
                <td>
                  <v-skeleton-loader
                    type="text"
                    class="custom-skeleton table-rows-text"
                  ></v-skeleton-loader>
                </td>
              </tr>
            </template>
            <tr v-else-if="!pageLoading">
              <td colspan="4">
                <p
                  class="m-0 row-not-found text-center font-weight-500 font-size-16"
                >
                  <img
                    :src="$assetURL('media/error/empty.png')"
                    class="row-not-found-image"
                  />
                  Uhh... There are no leave at the moment.
                </p>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </ListingTable>
  </span>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import moment from "moment-timezone";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";

import { GET } from "@/core/services/store/request.module";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  mixins: [CommonMixin],
  name: "login-log",
  props: {
    engineer_id: {
      type: Number,
      default: null,
    },
  },
  watch: {},
  components: {
    ListingTable,
  },
  data() {
    return {
      leaveId: null,
      visits: [],
      leaveTypes: [],
      engineerLeave: [],
      pageLoading: true,
      loglist: [],
    };
  },
  computed: {},
  methods: {
    formatDateStartTime(row) {
      return moment(row).format("hh:mm A");
    },
    toLeaves(id) {
      if (!id) {
        return false;
      }
      this.$router.push({
        name: "admin.leave.detail",
        params: { id },
      });
    },
    getLeaveTypes() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "get-engineer-leave/" + this.engineer_id })
        .then(({ data }) => {
          _this.engineerLeave = data;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },

  mounted() {
    this.getLeaveTypes();
  },
};
</script>
